import type { IDirective } from "angular";
import { module } from "angular";
import "@progress/kendo-ui/js/kendo.combobox";
import "./InputComboBoxDirective.scss";

export default class InputComboBoxDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public scope = {
        irLabel: "<",
        irOptions: "<",
        irTextField: "<",
        irValueField: "<",
        ngModel: "=",
        ngRequired: "<",
    };

    public template: string;

    constructor(private readonly $timeout: ng.ITimeoutService) {
        this.template = `<select kendo-combo-box k-data-source="irOptions"
                            aa-label="{{irLabel | translate}}" aa-field-group="ngModel"
                            k-data-value-field="irValueField" k-data-text-field="irTextField"
                            ng-model="ngModel" k-auto-bind="true" class="ir-combobox ng-animate-disabled"
                            ng-required="{{ngRequired}}">
                      </select>`;
    }

    public link(scope: any, instanceElement: JQuery<HTMLElement>) {
        instanceElement.change(() => this.clearNgModelIfInputIsEmpty(scope, instanceElement));
    }

    private clearNgModelIfInputIsEmpty(scope: any, instanceElement: JQuery<HTMLElement>) {
        this.$timeout(() => {
            if (this.isInputEmpty(instanceElement)) {
                scope.ngModel = "";
            }
        });
    }

    private isInputEmpty(comboBoxElement: JQuery<HTMLElement>) {
        const kendoInputSelector = ".k-input";
        return comboBoxElement.find(kendoInputSelector).val() === "";
    }
}

module("mmGui").directive("irInputComboBox", [
    "$timeout",
    ($timeout: ng.ITimeoutService) => new InputComboBoxDirective($timeout),
]);
